import { render, staticRenderFns } from "./IndemnityTemplateTable.vue?vue&type=template&id=579e0684&scoped=true"
import script from "./IndemnityTemplateTable.vue?vue&type=script&lang=js"
export * from "./IndemnityTemplateTable.vue?vue&type=script&lang=js"
import style0 from "./IndemnityTemplateTable.vue?vue&type=style&index=0&id=579e0684&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "579e0684",
  null
  
)

export default component.exports